import { render, staticRenderFns } from "./AvatarIcon.vue?vue&type=template&id=d125dc22&scoped=true"
import script from "./AvatarIcon.vue?vue&type=script&lang=js"
export * from "./AvatarIcon.vue?vue&type=script&lang=js"
import style0 from "./AvatarIcon.vue?vue&type=style&index=0&id=d125dc22&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d125dc22",
  null
  
)

export default component.exports